import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import Navbar from '../../components/navbar/navbar'
import { useCallback, useEffect, useRef, useState } from 'react'
import { CustomInputDate } from '../../components/CustomInputDate'
import apinode from '../../services/apinode'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { Lightning, UserCircle } from '@phosphor-icons/react'
import {
  Badge,
  Divider,
  Item,
  Order,
  OrdersSection,
  SectionInfo,
  SectionPlusInfo,
  Text,
  Total,
  User,
} from './styles'
import ReactPaginate from 'react-paginate'
import { formatDate } from '../../utils/formatDate'
import { formatPrice } from '../../utils/formatPrice'
import { unifyParams } from '../../utils/unifyParams'
import {
  ArrowClockwise,
  CaretDownFill,
  CaretUpFill,
  CloudArrowDownFill,
  Search,
} from 'react-bootstrap-icons'
import noDataPc from '../../assets/illustration/no-data-pc.svg'
import { CustomButton } from '../../components/CustomButton'
import { CustomSpinner } from '../../components/CustomSpinner'
import { formatCPF } from '../../utils/formatCPF'
import { ContentLoading } from '../../components/ContentLoading'
import { Center } from '../../components/Center'

export function MercadoLivrePedidos() {
  const [orders, setOrders] = useState([])
  const [accounts, setAccounts] = useState([])
  const [totalOrders, setTotalOrders] = useState(0)
  const [inputSearch, setInputSearch] = useState('')
  const [selectedOrder, setSelectedOrder] = useState('')
  const [selectedAccount, setSelectedAccount] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('')
  const [selectedDate, setSelectedDate] = useState()
  const [isLoadingOrders, setIsLoadingOrders] = useState(true)
  const [isLoadingOrder, setIsLoadingOrder] = useState({})
  const [isLoadingAccounts, setIsLoadingAccounts] = useState(true)
  const [itemsPerPage, _] = useState(51)
  const [itemOffset, setItemOffset] = useState(0)
  const [pageCount, setPageCount] = useState(0)
  const [pageNumber, setPageNumber] = useState(0)
  const [isImportOrderLoading, setIsImportOrderLoading] = useState({})

  const totalItems = selectedOrder.items
    ? selectedOrder?.items.reduce((acc, item) => {
        acc += item.unit_price * item.quantity

        return acc
      }, 0)
    : 0

  const totalItemsDiscount = selectedOrder.items
    ? selectedOrder?.items.reduce((acc, item) => {
        if (item?.sale_fee) {
          acc += item.sale_fee * item.quantity
        }

        return acc
      }, 0) + selectedOrder.base_cost
    : 0

  const inputSearchRef = useRef(null)

  const statusMap = {
    confirmed: 'Confirmado',
    payment_required: 'Pagamento necessário',
    payment_in_process: 'Pagamento em processo',
    paid: 'Pago',
    cancelled: 'Cancelado',
    invalid: 'Inválido',
  }

  const statusColorMap = {
    confirmed: '#16a085',
    payment_required: '#f1c40f',
    payment_in_process: '#d35400',
    paid: '#229954',
    cancelled: '#c0392b',
    invalid: '#aeb6bf',
  }

  const statusMapArray = Object.entries(statusMap)

  async function handleImportOrder(index) {
    try {
      setIsImportOrderLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      //
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao importar esse pedido.')
    } finally {
      setIsImportOrderLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function getOrder(orderId, index) {
    try {
      setIsLoadingOrder((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const response = await apinode.get(
        `/ordersml/orders/${orderId}/${selectedAccount}`,
      )

      setSelectedOrder(response.data)
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível buscar as informações do order!',
      )
    } finally {
      setIsLoadingOrder((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  const buscarPedidos = useCallback(async () => {
    try {
      if (selectedAccount) {
        setIsLoadingOrders(true)

        let url = `/ordersml/orders/${selectedAccount}`

        const urlParams = unifyParams(url, [
          { key: 'date', value: selectedDate },
          { key: 'status', value: selectedStatus },
          { key: 'offset', value: itemOffset },
          { key: 'search', value: inputSearch },
        ])

        const response = await apinode.get(urlParams)

        setPageNumber(response.data.paging.offset / response.data.paging.limit)
        setTotalOrders(response.data.paging.total)
        setPageCount(Math.ceil(response.data.paging.total / itemsPerPage))
        setOrders(response.data.results)
      }
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar os pedidos!')
    } finally {
      setIsLoadingOrders(false)
    }
  }, [
    inputSearch,
    itemOffset,
    itemsPerPage,
    selectedAccount,
    selectedDate,
    selectedStatus,
  ])

  async function buscarContas() {
    try {
      setIsLoadingAccounts(true)

      const response = await apinode.get(
        `/anuncios/contas/${localStorage.idconta}`,
      )

      const responseFormatted = response.data.sort((a, b) =>
        a.APELIDO.localeCompare(b.APELIDO),
      )

      setAccounts(responseFormatted)
      setSelectedAccount(responseFormatted[0].ID_CONTA)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar as contas!')
    } finally {
      setIsLoadingAccounts(false)
    }
  }

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % totalOrders
    setItemOffset(newOffset)
  }

  useEffect(() => {
    const fetchAccounts = async () => {
      await buscarContas()
    }

    fetchAccounts()
  }, [])

  useEffect(() => {
    buscarPedidos()
  }, [buscarPedidos])

  return (
    <>
      <Navbar />

      <div className="mt-page">
        <h1>Pedidos Mercado Livre</h1>

        <Center mb={20}>
          <CustomButton
            title="Atualizar"
            onClick={buscarPedidos}
            isLoadingText="Atualizando..."
            isLoading={isLoadingOrders}
            noMargin
          >
            <ArrowClockwise />
          </CustomButton>
        </Center>

        <Row>
          <Col>
            <Form.Select
              value={selectedStatus}
              onChange={(e) => {
                setItemOffset(0)
                setSelectedStatus(e.target.value)
              }}
            >
              <option value="">Selecione uma opção</option>
              {statusMapArray.map(([key, value]) => (
                <option
                  key={key}
                  value={key}
                >
                  {value}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col>
            <CustomInputDate
              selected={selectedDate}
              onChange={(date) => {
                setItemOffset(0)
                setSelectedDate(date)
              }}
              placeholderText="Data da venda"
              isClearable
            />
          </Col>

          <Col>
            <div
              style={{
                display: 'flex',
              }}
            >
              <Form.Control
                ref={inputSearchRef}
                placeholder="ID, Comprador, Nickname"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setItemOffset(0)
                    setInputSearch(inputSearchRef.current.value)
                  }
                }}
              />

              <CustomButton
                isLoading={isLoadingOrders}
                onClick={() => {
                  setItemOffset(0)
                  setInputSearch(inputSearchRef.current.value)
                }}
              >
                <Search />
              </CustomButton>
            </div>
          </Col>

          <Col>
            <Form.Select
              value={selectedAccount}
              onChange={(e) => {
                setItemOffset(0)
                setSelectedAccount(e.target.value)
              }}
              disabled={isLoadingAccounts}
            >
              {accounts.map((conta) => (
                <option
                  key={conta.ID_CONTA}
                  value={conta.ID_CONTA}
                >
                  {conta.APELIDO}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        <div className="mt-4">
          <ContentLoading
            isLoading={isLoadingAccounts}
            loadingText="Carregando contas..."
          >
            <ContentLoading
              isLoading={isLoadingOrders}
              loadingText="Carregando pedidos..."
            >
              <>
                {orders.length === 0 ? (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <img
                      src={noDataPc}
                      alt=""
                      style={{
                        width: 450,
                        height: 300,
                      }}
                    />

                    <h1
                      style={{
                        fontSize: 18,
                      }}
                    >
                      Sem pedidos encontrados!
                    </h1>
                  </div>
                ) : (
                  <OrdersSection>
                    {orders.map((order, index) => (
                      <Order
                        key={order.id}
                        backColor="#fff"
                      >
                        <SectionInfo>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 10,
                            }}
                          >
                            <Badge backColor={statusColorMap[order.status]}>
                              {statusMap[order.status]}
                            </Badge>

                            {order.fulfilled && (
                              <OverlayTrigger overlay={<Tooltip>Full</Tooltip>}>
                                <Lightning
                                  weight="fill"
                                  size={25}
                                  color="#229954"
                                />
                              </OverlayTrigger>
                            )}
                          </div>

                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              gap: 10,
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 10,
                              }}
                            >
                              <strong>
                                {order.id} | {order.customer}
                              </strong>

                              <OverlayTrigger
                                overlay={
                                  <Tooltip>
                                    {order.imported
                                      ? 'Importado'
                                      : 'Não importado'}
                                  </Tooltip>
                                }
                              >
                                <CloudArrowDownFill
                                  color={order.imported ? '#229954' : '#A7A2A9'}
                                  size={26}
                                />
                              </OverlayTrigger>
                            </div>

                            <span>
                              {formatDate(
                                order.date_created,
                                'dd/MM/yyyy HH:mm',
                              )}
                            </span>

                            {!order.imported && (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: 10,
                                }}
                              >
                                <CustomButton
                                  title="Importar"
                                  onClick={handleImportOrder}
                                  isLoading={isImportOrderLoading[index]}
                                  isLoadingText="Importando..."
                                >
                                  <CloudArrowDownFill />
                                </CustomButton>
                              </div>
                            )}
                          </div>

                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 10,
                            }}
                          >
                            <Badge backColor="#229954">
                              {formatPrice(order.total_amount)}
                            </Badge>

                            {isLoadingOrder[index] ? (
                              <CustomSpinner size={20} />
                            ) : selectedOrder.id === order.id ? (
                              <CaretUpFill
                                style={{
                                  cursor: 'pointer',
                                }}
                                onClick={() => setSelectedOrder({})}
                              />
                            ) : (
                              <CaretDownFill
                                style={{
                                  cursor: 'pointer',
                                }}
                                onClick={() => getOrder(order.id, index)}
                              />
                            )}
                          </div>

                          <Badge>{order.seller}</Badge>
                        </SectionInfo>

                        {selectedOrder?.id === order.id && (
                          <SectionPlusInfo>
                            <Item>
                              {selectedOrder?.items.map((item) => (
                                <>
                                  <div
                                    style={{
                                      display: 'flex',
                                      gap: 30,
                                    }}
                                  >
                                    <img
                                      src={item?.thumbnail}
                                      alt=""
                                    />

                                    <div>
                                      <Text>{item?.title}</Text>
                                      <Text>SKU: {item?.sku}</Text>
                                      <Text>
                                        {item?.quantity}{' '}
                                        {item?.quantity > 1
                                          ? 'unidades'
                                          : 'unidade'}{' '}
                                        | {formatPrice(item?.unit_price)}
                                      </Text>

                                      {item?.variation_attributes.map(
                                        (attr) => (
                                          <Text>
                                            {attr?.name}: {attr?.value_name}
                                          </Text>
                                        ),
                                      )}
                                    </div>
                                  </div>

                                  <hr />
                                </>
                              ))}
                            </Item>

                            <User>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 3,
                                  marginBottom: 20,
                                }}
                              >
                                <UserCircle size={20} />
                                <Text>{selectedOrder?.customer}</Text>
                              </div>
                              <Text>
                                {selectedOrder?.shippingAddress?.street_name},{' '}
                                {selectedOrder?.shippingAddress?.street_number},{' '}
                                {selectedOrder?.shippingAddress?.neighborhood} -{' '}
                                {selectedOrder?.shippingAddress?.city}/
                                {selectedOrder?.shippingAddress?.state} - CEP:{' '}
                                {selectedOrder?.shippingAddress?.zipcode}
                              </Text>
                              <hr />

                              <Text mb={20}>Dados da fatura</Text>

                              {selectedOrder?.billingAddress?.customer && (
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 3,
                                  }}
                                >
                                  <UserCircle size={20} />
                                  <Text>
                                    {selectedOrder?.billingAddress?.customer}
                                  </Text>
                                </div>
                              )}

                              <Text>CPF: {formatCPF(selectedOrder?.cpf)}</Text>
                              <Text>
                                {selectedOrder?.billingAddress?.street_name},{' '}
                                {selectedOrder?.billingAddress?.street_number},{' '}
                                {selectedOrder?.billingAddress?.neighborhood} -{' '}
                                {selectedOrder?.billingAddress?.city}/
                                {selectedOrder?.billingAddress?.state} - CEP:{' '}
                                {selectedOrder?.billingAddress?.zipcode}
                              </Text>
                            </User>

                            <Total>
                              <Divider>
                                <Text>Produtos</Text>
                                <Text>{formatPrice(totalItems)}</Text>
                              </Divider>

                              <hr />

                              {selectedOrder?.items.map((item) => (
                                <Divider>
                                  <Text>
                                    {String(`Tarifa ${item.title}`).slice(
                                      0,
                                      40,
                                    )}
                                    ...
                                  </Text>

                                  <Text>
                                    -
                                    {formatPrice(item.sale_fee * item.quantity)}
                                  </Text>
                                </Divider>
                              ))}

                              <Divider>
                                <Text>Envio pelo Mercado Envios</Text>
                                <Text>
                                  -{formatPrice(selectedOrder?.base_cost)}
                                </Text>
                              </Divider>

                              <hr />

                              {console.log(totalItems, totalItemsDiscount)}

                              <Divider>
                                <Text strong>Total</Text>
                                <Text strong>
                                  {formatPrice(totalItems - totalItemsDiscount)}
                                </Text>
                              </Divider>
                            </Total>
                          </SectionPlusInfo>
                        )}
                      </Order>
                    ))}

                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Próxima"
                      initialPage={pageNumber}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="Anterior"
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </OrdersSection>
                )}
              </>
            </ContentLoading>
          </ContentLoading>
        </div>
      </div>
    </>
  )
}
